/**
 * Тост «подложка недоступна — переключились на запасную» (задача владельца
 * 24.09.2026, п.2): гаснет сам, как ArNoticeToast в app.tsx.
 */
import { tr } from '@app/i18n'
import { useEffect } from 'preact/hooks'
import { basemapFallbackNotice, dismissBasemapFallbackNotice } from '../map/basemap-fallback-notice'

export function BasemapFallbackToast() {
  const shownAt = basemapFallbackNotice.value
  useEffect(() => {
    if (!shownAt) return
    const timer = setTimeout(dismissBasemapFallbackNotice, 4000)
    return () => clearTimeout(timer)
  }, [shownAt])
  if (!shownAt) return null
  return (
    <p class="ar-toast" role="status">
      {tr('basemap.fallback_notice')}
    </p>
  )
}
